












































import { Component, Prop } from 'vue-property-decorator';
import CourseCardBase from '@/components/atoms/CourseCardBase.vue';
import CourseType from '@/components/atoms/CourseType.vue';
import CourseStatus from '@/components/atoms/CourseStatus.vue';
import NewcrossButton from '@/components/atoms/NewcrossButton.vue';
import NewcrossLoader from '@/components/atoms/NewcrossLoader.vue';
import CourseSessions from '@/components/organisms/CourseSessions.vue';
import HTMLContainer from '@/components/atoms/HTMLContainer.vue';
import {
  DoceboCourseSessionsResponse,
  DoceboEnrolmentStatus,
} from '@/lib/DoceboAPI';
import { HealthForceGoSkill } from '@/lib/HealthForceGoAPI';
import calculateExpiryStatus, {
  ExpiryStatus,
} from '@/lib/calculateExpiryStatus';

@Component({
  components: {
    CourseType,
    CourseStatus,
    NewcrossButton,
    NewcrossLoader,
    CourseSessions,
    HTMLContainer,
  },
})
export default class CourseCardClassoom extends CourseCardBase {
  @Prop() courseId!: string;

  @Prop() courseName!: string;

  @Prop() courseDescription!: string;

  @Prop() enrolmentStatus!: DoceboEnrolmentStatus | null;

  private get locked(): boolean {
    return this.enrolmentStatus === 'locked';
  }

  private get courseSessions(): DoceboCourseSessionsResponse | null {
    return this.$store.state.sessions.courseSessions[this.courseId];
  }

  private get courseSkills(): HealthForceGoSkill[] {
    return this.$store.getters['skills/getSkillsForCourse'](this.courseId);
  }

  private get showRenewButton(): boolean {
    const expiryStatus = calculateExpiryStatus(this.courseSkills);
    return [ExpiryStatus.EXPIRING_SOON, ExpiryStatus.EXPIRED].includes(
      expiryStatus
    );
  }

  private onDetailsToggle(e: Event) {
    const el = e.target as HTMLDetailsElement;
    if (el.open) {
      this.getCourseSessions(this.courseId);
    }
  }

  private getCourseSessions(courseId: string): Promise<void> {
    return this.$store.dispatch('sessions/GET_COURSE_SESSIONS', courseId, {
      root: true,
    });
  }

  private enrolOnCourse() {
    this.$store.dispatch('SET_LOADING_OVERLAY', 'Enrolling');
    this.$store
      .dispatch('enrolments/ENROL_COURSE', this.courseId, {
        root: true,
      })
      .then(
        () => this.getCourseSessions(this.courseId),
        (error) => {
          // Show error message returned from Docebo (Too many enrolments?)
          const dialog = this.$dialog.show({
            title: error.message[0],
            buttons: [
              {
                label: 'Ok',
                handler: () => dialog.dismiss(),
              },
            ],
          });
        }
      )
      .finally(() => this.$store.dispatch('SET_LOADING_OVERLAY', false));
  }

  private resetCourse() {
    const dialog = this.$dialog.show({
      title:
        'Are you sure you wish to renew this course? All previous course progress will be lost.',
      buttons: [
        {
          label: 'Cancel',
          handler: () => dialog.dismiss(),
        },
        {
          label: 'Renew',
          handler: () => {
            dialog.dismiss();
            this.$store.dispatch('SET_LOADING_OVERLAY', 'Renewing');
            this.$store
              .dispatch('enrolments/RESET_COURSE', this.courseId, {
                root: true,
              })
              .then(() => this.getCourseSessions(this.courseId))
              .then(() => this.$store.dispatch('SET_LOADING_OVERLAY', false));
          },
        },
      ],
    });
  }
}
